// test2839
(2839 && 0);
